import type { ComponentType } from "react";
import { localDayKey } from "../utils/date";
import type { EffectProps } from "./types";

import { FallingHearts } from "./FallingHearts";
import { FloatingBubbles } from "./FloatingBubbles";
import { SparkleStars } from "./SparkleStars";
import { CherryBlossoms } from "./CherryBlossoms";
import { FloatingBows } from "./FloatingBows";
import { GlitterRain } from "./GlitterRain";
import { HeartCursor } from "./HeartCursor";
import { RainbowPulse } from "./RainbowPulse";
import { KittyFaces } from "./KittyFaces";
import { Strawberries } from "./Strawberries";
import { Confetti } from "./Confetti";
import { Butterflies } from "./Butterflies";
import { TwinklingStars } from "./TwinklingStars";

export type { EffectProps } from "./types";

export type Effect = {
  id: string;
  name: string;
  emoji: string;
  Component: ComponentType<EffectProps>;
};

export const EFFECTS: readonly Effect[] = [
  { id: "falling-hearts",   name: "falling hearts",     emoji: "💖", Component: FallingHearts },
  { id: "floating-bubbles", name: "floating bubbles",   emoji: "🫧", Component: FloatingBubbles },
  { id: "sparkle-stars",    name: "sparkle magic",      emoji: "✨", Component: SparkleStars },
  { id: "cherry-blossoms",  name: "cherry blossoms",    emoji: "🌸", Component: CherryBlossoms },
  { id: "floating-bows",    name: "floating bows",      emoji: "🎀", Component: FloatingBows },
  { id: "glitter-rain",     name: "glitter rain",       emoji: "🌟", Component: GlitterRain },
  { id: "heart-cursor",     name: "heart cursor",       emoji: "💘", Component: HeartCursor },
  { id: "rainbow-pulse",    name: "rainbow dream",      emoji: "🌈", Component: RainbowPulse },
  { id: "kitty-faces",      name: "kitty pop",          emoji: "🐱", Component: KittyFaces },
  { id: "strawberries",     name: "strawberry shower",  emoji: "🍓", Component: Strawberries },
  { id: "confetti",         name: "confetti party",     emoji: "🎊", Component: Confetti },
  { id: "butterflies",      name: "butterfly garden",   emoji: "🦋", Component: Butterflies },
  { id: "twinkling-stars",  name: "twinkling stars",    emoji: "⭐", Component: TwinklingStars },
];

export function dailyEffect(now: Date = new Date()): Effect {
  const idx = ((localDayKey(now) % EFFECTS.length) + EFFECTS.length) % EFFECTS.length;
  return EFFECTS[idx] as Effect;
}
